module.exports = __webpack_public_path__ + "img/1556928249.cff90776.jpg";